import type { Dispatch, PropsWithChildren, SetStateAction } from 'react'
import React, { createContext, useContext, useState } from 'react'
import type { AvailableLocales } from '../locales'

interface LocaleProviderProps {
  locale?: LocaleState
}

type LocaleState = keyof AvailableLocales

type UseLocaleValues = [LocaleState, Dispatch<SetStateAction<LocaleState>>]

export const LocaleContext = createContext<UseLocaleValues | null>(null)

export const useLocale = (): UseLocaleValues =>
  useContext(LocaleContext) as UseLocaleValues

function LocaleProvider({
  children,
  locale = 'en',
}: PropsWithChildren<LocaleProviderProps>): JSX.Element {
  const [language, setLanguage] = useState(locale)

  return (
    <LocaleContext.Provider value={[language, setLanguage]}>
      {children}
    </LocaleContext.Provider>
  )
}

export { LocaleProvider }
